import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class ChecksumCalculatorService {

  public async CalculateSHA512(file: File): Promise<string> {
    let sha512 = CryptoJS.algo.SHA512.create();
    const sliceSize = 10_485_760; // 10 MiB
    let start = 0;
    while (start < file.size) {
      const slice: Uint8Array = await this.readSlice(file, start, sliceSize);
      const wordArray = CryptoJS.lib.WordArray.create(slice as any);
      sha512 = sha512.update(wordArray);
      start += sliceSize;
    }
    return sha512.finalize().toString().toUpperCase();
  }

  private async readSlice(
    file: File,
    start: number,
    size: number
  ): Promise<Uint8Array> {
    return new Promise<Uint8Array>((resolve, reject) => {
      const fileReader = new FileReader();
      const slice = file.slice(start, start + size);
      fileReader.onload = () =>
        resolve(new Uint8Array(fileReader.result as any));
      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(slice);
    });
  }
}
